module.exports = __webpack_public_path__ + "static/media/image-4.4b59281d.avif";